
import React, { useEffect, useState } from 'react';

import Form, { Item as FormItem, GroupItem, ColCountByScreen } from 'devextreme-react/form';

import { FormTextbox, FormPhotoUploader, FormDateBox } from '../..';
import { EmailRule } from 'devextreme-react/validator';
import { getSizeQualifier } from '../../../utils/media-query';
import { FormSelectBox } from '../../utils/form-selectbox/FormSelectBox';
import { GENDERS } from '../../../shared/constants';

export const ClubNewForm = ({ initData, onDataChanged, clubData, traininggroupData }) => {
  const [newClubData, setNewClubData] = useState({ ...initData });

  useEffect(() => {
    setNewClubData({ ...initData });
  }, [initData]);

  const updateField = (field) => (value) => {
    const newData = { ...newClubData, ...{ [field]: value } };

    onDataChanged(newData);
    setNewClubData(newData);
  };

  return (
    <Form
      className='plain-styled-form'
      screenByWidth={getSizeQualifier}
    >
     
      <GroupItem>
        
        <FormItem>
          <FormTextbox
            label='Vereinsname'
            value={newClubData.clubname}
            isEditing={false}
            onValueChange={updateField('clubname')}
          />
        </FormItem>
       
      </GroupItem>


    </Form>
  );
};
